import React, { useState } from 'react';
import { Container } from '@mui/material';
import { JobCard } from '../Cards/JobCard';
import { IActivityFeedItem, TActivityLikeCategory } from '../../redux/activity/types';
import { FeedProjectCard } from '../Cards/FeedProjectCard';
import { FeedContestCard } from '../Cards/FeedContestCard';
import { EventsCard } from '../Cards/EventCard';
import { ThoughtCard } from '../Cards/ThougthCard';
import { FeedContentDisplayModal } from './FeedContentDisplayModal';
import { useSelector } from 'react-redux';
import { activityLikeActionInProgressSelector } from '../../selectors/selectors';
import { useDispatch } from 'react-redux';
import { deleteActivityLike, likeActivity } from '../../redux/activity/actions';
import { navigate } from '../../redux/navigator/action';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { ROUTES } from '../../types/global/routes.types';
import { IContest, IProject } from '../../types/global/helper';
import { setmedia } from '../../redux/project/actions';
// import { mergeContestActivities } from '../../utils/reponseProcessorII';

export interface IFeedContainerProps {
    activities: IActivityFeedItem[];
    onRecommendClick: (type: string, model: any) => void;
    onJoinCampaign: (type: string, model: any) => void;
    onRegister: (type: string, model: any) => void;
    onSubmitClick: (type: string, model: any) => void;
    onBookmarkJob: (type: string, model: any) => void;
    onDeleteBookmark: (type: string, bookmarkId: string, model: any) => void;
    onDetailsClick: (type: string, model: any) => void;
    onViewClick?: (type: string, model: any) => void;
    onCommentClick?: (type: string, model: any) => void;
    onLikeClick?: (type: string, model: any) => void;
}
export const FeedContainer: React.FC<IFeedContainerProps> = ({
    activities,
    onRecommendClick,
    onDetailsClick,
    onBookmarkJob,
    onDeleteBookmark,
    onSubmitClick,
    onCommentClick,
    onLikeClick,
    onViewClick,
    onRegister,
    onJoinCampaign,
}) => {
    // const { merged, updated } = mergeContestActivities(activities);
    const [thoughtModal, setThoughtModal] = useState<null | { activity: IActivityFeedItem }>(null);
    const [, setEventModal] = useState<null | { activity: IActivityFeedItem }>(null);
    const [campaignModal, setCampaignModal] = useState<null | { activity: IActivityFeedItem }>(null);
    const [, setProjecfModal] = useState<null | { activity: IActivityFeedItem }>(null);
    const [, setJobModal] = useState<null | { activity: IActivityFeedItem }>(null);
    const likingInProgress = useSelector(activityLikeActionInProgressSelector);
    const dispatch = useDispatch();

    const handleModal = (activity: IActivityFeedItem, category: TActivityLikeCategory) => {
        switch (category) {
            case 'thougth':
                setThoughtModal({ activity });
                break;
            case 'campaign':
                setCampaignModal({ activity });
                break;
            case 'job':
                setJobModal({ activity });
                break;
            case 'event':
                setEventModal({ activity });
                break;
            case 'project':
                setProjecfModal({ activity });
                break;
        }
    };
    const handleCloseThoughtModal = () => {
        setThoughtModal(null);
        setEventModal(null);
        setCampaignModal(null);
        setProjecfModal(null);
        setJobModal(null);
    };

    const handleLikeClick = (activity: any, category: TActivityLikeCategory) => {
        // Don't proceed if liking is already in progress
        if (likingInProgress) {
            return;
        }

        if (activity?.is_user_liked && activity?.user_like && activity.user_like.length > 0) {
            // User wants to unlike - use deleteActivityLike
            dispatch(
                deleteActivityLike({
                    likeId: activity.user_like[0]._id,
                    activityId: activity._id,
                    like_category: category,
                    like_origin: 'details',
                    additionalPayload: activity,
                }),
            );
        } else {
            // User wants to like - use likeActivity
            dispatch(
                likeActivity({
                    activityId: activity._id,
                    like_category: category,
                    like_type: 'like',
                    like_origin: 'details',
                }),
            );
        }
    };

    const handleJoinCampaign = (contest: IContest) => {
        let route = replaceRouteParam(ROUTES.ESVIEW_CONTEST, 'contestId', contest.slug!);

        dispatch(
            navigate({
                routes: route,
            }),
        );
    };

    const handleProjects = (project: IProject) => {
        dispatch(
            setmedia({
                media: project,
                mediaType: 'act',
            }),
        );
    };

    return (
        <Container disableGutters sx={{ my: 2 }}>
            {activities.map((activity, index) => {
                if (activity.activity?.model) {
                    switch (activity.activity_type) {
                        case 'applied to a gig':
                        case 'created a gig':
                        case 'got hired':
                        case 'shared a gig':
                        case 'is casting':
                        case 'is hiring':
                            return (
                                <JobCard
                                    key={index}
                                    job={activity}
                                    onRecommendClick={() => onRecommendClick('gig', activity.activity?.model)}
                                    onDetailsClick={() => onDetailsClick('gig', activity.activity?.model)}
                                    onBookmarkJob={() => onBookmarkJob('gig', activity.activity?.model)}
                                    onDeleteBookmark={id => onDeleteBookmark('gig', id, activity.activity?.model)}
                                />
                            );
                        case 'created a project':
                        case 'commented on project':
                        case 'liked a project':
                        case 'viewed a project':
                            return (
                                <FeedProjectCard
                                    project={activity}
                                    key={index}
                                    onCommentClick={() => {
                                        handleProjects(activity.activity?.model as IProject);
                                        onCommentClick && onCommentClick('project', activity.activity?.model);
                                    }}
                                    onLikeClick={() => {
                                        onLikeClick && onLikeClick('project', activity.activity?.model);
                                        handleLikeClick(activity.projects_activity, 'project');
                                    }}
                                    onViewClick={() => {
                                        handleProjects(activity.activity?.model as IProject);
                                        onViewClick && onViewClick('project', activity.activity?.model);
                                    }}
                                    onClickPlay={() => handleProjects(activity.activity?.model as IProject)}
                                />
                            );
                        case 'created a contest':
                        case 'joined a contest':
                        case 'liked a contest':
                        case 'won a contest 🥳🥳🥳🥳🚀🚀🚀🚀🎉🎉🎉🎉':
                        case 'commented on contest':
                            return (
                                <FeedContestCard
                                    contest={activity}
                                    key={index}
                                    onCommentClick={() => handleModal(activity, 'campaign')}
                                    onJoinCampaignClick={() => {
                                        handleJoinCampaign(activity.activity?.model as IContest);
                                    }}
                                    onLikeClick={() => {
                                        handleLikeClick(activity.activity?.model, 'contest');
                                    }}
                                />
                            );
                        case 'created an event':
                            return (
                                <EventsCard
                                    event={activity}
                                    key={index}
                                    onRecommendClick={() => onRecommendClick('gig', activity.activity?.model)}
                                    onRegisterEventClick={() =>
                                        onRegister && onRegister('gig', activity.activity?.model)
                                    }
                                />
                            );
                        case 'commented on a thougth':
                        case 'created a thougth':
                        case 'liked a thougth':
                        case 'shared a thougth':
                            return (
                                <React.Fragment key={index}>
                                    <ThoughtCard
                                        activity={activity}
                                        key={index}
                                        onCommentClick={() => handleModal(activity, 'thougth')}
                                        onLikeClick={() =>
                                            onLikeClick && onLikeClick('thougth', activity.activity?.model)
                                        }
                                        onViewClick={() => handleModal(activity, 'thougth')}
                                    />
                                </React.Fragment>
                            );
                    }
                }
                return <div key={index} />;
            })}
            {/* Thought Modal */}

            <FeedContentDisplayModal
                open={!!thoughtModal}
                categoryId={thoughtModal?.activity?.activity?.model?._id || ''}
                category="thougth"
                component={<ThoughtCard activity={thoughtModal?.activity} previewMode />}
                onClose={handleCloseThoughtModal}
                title={`${thoughtModal?.activity?.created_by?.firstName}'s thougth.` || 'Poster'}
            />
            <FeedContentDisplayModal
                open={!!campaignModal}
                categoryId={campaignModal?.activity?.activity?.model?._id || ''}
                category="contest"
                component={<FeedContestCard contest={campaignModal?.activity!} />}
                onClose={handleCloseThoughtModal}
                title={`${campaignModal?.activity?.created_by?.firstName}'s campaign.` || 'Poster'}
            />
        </Container>
    );
};
